import React, { useEffect, useRef, useState } from "react";
// css
import classes from "./EventBanner.module.css";
import deleteIcon from "../../../../assets/svg/action/delete-circle.svg";
import addCircleIcon from "../../../../assets/svg/add-circle.svg";
import { ActionButton, Button, Container, Icon, Notifications, Text } from "@jds/core";
import { Box, Stack } from "@mui/material";
import FormErrorLabel from "../../FormErrorLabel/FormErrorLabel";
import {
  baseToImg,
  bytesToMB,
  imgValidationCheck,
  validateFileSignature,
} from "../../../../util/helper";
import CardOverlay from "../../Cards/CardOverlay";
const EventBannerInput = (props) => {
  const {
    fileValue = () => { },
    initialValue,
    resetValue,
    errorText,
    defaultBanner,
    chooseEventImgClickHandler,
    selectedEventType,
    disableBannerCTA,
    showGalleryCTA = true,
  } = props;
  const [bannerImg, setBannerImg] = useState(initialValue);
  const fileInputRef = useRef(null);
  const handleClick = () => {
    fileInputRef.current.click();
  };
  useEffect(() => { }, []);
  // useEffect(() => {
  //   setBannerImg(null);
  // }, [resetValue]);
  return (
    <>
      <input
        type="file"
        id="eventBanner"
        name="banner_img"
        accept=".jpg"
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files[0];

          if (imgValidationCheck(e, null, 5)) {
            validateFileSignature(file, {
              jpeg: ["ffd8ffe0", "ffd8ffe1", "ffd8ffe2", "ffd8ffdb"], // JPEG signatures can vary
              png: ["89504e47"],
            })
              .then((isValid) => {
                if (isValid) {
                  setBannerImg(e.target.files[0]);
                  fileValue(e.target.files[0]);
                } else {
                  Notifications.toast.error({
                    id: "event-banner-input-img",
                    title:
                      // "Please upload a valid image file (JPG, JPEG and PNG).",
                      bytesToMB(file.size).toFixed(1) > 5
                        ? "File size exceeds the limit."
                        : "Please upload a valid .jpg file.",
                  });
                }
              })
              .catch((error) => {
                Notifications.toast.error({
                  id: "event-banner-input-img",
                  title:
                    // "Please upload a valid image file (JPG, JPEG and PNG).",
                    bytesToMB(file.size).toFixed(1) > 5
                      ? "File size exceeds the limit."
                      : "Please upload a valid .jpg file.",
                });
              });
          } else {
            Notifications.toast.error({
              id: "event-banner-input-img",
              // title: "Please upload a valid image file (JPG, JPEG and PNG).",
              title:
                bytesToMB(file.size).toFixed(1) > 5
                  ? "File size exceeds the limit."
                  : "Please upload a valid .jpg file.",
            });
          }
        }}
        ref={fileInputRef}
      />
      {bannerImg && (
        <div className={classes.bannerDiv}>
          <img
            src={URL.createObjectURL(bannerImg)}
            className={classes.bannerImg}
          />
          {/* <img
            src={deleteIcon}
            className={classes.deleteIcon}
            onClick={() => {
              fileInputRef.current.value = null
              setBannerImg(null);
              fileValue(null);
            }}
          /> */}

          {!disableBannerCTA &&
            <>
              <Stack direction='row' className={classes['action-container']} justifyContent='center' gap={2}>
                {showGalleryCTA && (
                  <ActionButton
                    kind="secondary"
                    appearance="contrast"
                    label="Choose from gallery"
                    onClick={() => {
                      chooseEventImgClickHandler();
                      if (selectedEventType) {
                        fileInputRef.current.value = null
                        setBannerImg(null);
                        fileValue(null);
                      }
                    }}
                  />
                )}
                <ActionButton
                  kind="secondary"
                  appearance="contrast"
                  label="Upload from device"
                  onClick={() => handleClick()}
                />
              </Stack>
              <CardOverlay className={classes['banner-overlay']} />
            </>
          }
        </div>
      )}
      {!bannerImg && !defaultBanner && (
        <>
          <label htmlFor="eventBanner">
            <Container
              paddingTop={24}
              paddingBottom={24}
              radius={16}
              backgroundColor="{primaryGrey20}"
              fullWidth
              direction="column"
              verticalAlign="center"
              horizontalAlign="center"
              gap={8}
              style={{ marginBottom: "16px" }}
            >
              {/* <span style={{ opacity: "0.5" }}>
                <Icon ic="IcAddCircle" size="xtra-large" />
              </span> */}
              <Text
                text="Upload the image for the event banner"
                color="primary_grey_60"
                appearance="body-s"
              />

              <Container style={{ marginTop: "24px" }}>
                <Button
                  conponent="label"
                  label="Upload"
                  iconLeft="IcAdd"
                  kind="secondary"
                  size="large"
                  onClick={() => {
                    handleClick();
                  }}
                />
              </Container>
              <Container fullWidth style={{ padding: "16px 24px 0" }}>
                <Container verticalAlign="top" gap={8}>
                  <Box sx={{ mt: "4px" }}>
                    <Icon ic={"IcInfo"} size="s" color="primary_grey_80" />
                  </Box>
                  <Text
                    text="File Type: .jpg, .png, Banner Size: 384x216px , Max Size: 5 MB"
                    appearance="body-s"
                    color="primary_grey_60"
                  />
                </Container>
              </Container>
            </Container>
            {errorText && <FormErrorLabel errorMsg={errorText} />}
          </label>
        </>
      )}
      {!bannerImg && defaultBanner && (
        <div className={classes.bannerDiv}>
          {/* <img src={baseToImg(defaultBanner)} className={classes.bannerImg} /> */}
          <img src={defaultBanner} className={classes.bannerImg} />
          {/* <div className={classes.deleteIcon}>
            <Icon
              ic={"IcEditPen"}
              onClick={() => {
                handleClick();
              }}
            />
          </div> */}
          {!disableBannerCTA &&
            <>
              <Stack direction='row' className={classes['action-container']} justifyContent='center' gap={2}>
                {showGalleryCTA && (
                  <ActionButton
                    kind="secondary"
                    appearance="contrast"
                    label="Choose from gallery"
                    onClick={() => {
                      chooseEventImgClickHandler();
                      if (selectedEventType) {
                        fileInputRef.current.value = null
                        setBannerImg(null);
                        fileValue(null);
                      }
                    }
                    }
                  />
                )}
                <ActionButton
                  kind="secondary"
                  appearance="contrast"
                  label="Upload from device"
                  onClick={() => handleClick()}
                />
              </Stack>
              <CardOverlay className={classes['banner-overlay']} />
            </>
          }
        </div>
      )}
    </>
  );
};
export default React.memo(EventBannerInput);
